export const onrejected = error => {
    console.error("[[onrejected]] error", error);
    return {
        success: false,
        error: error.response?.data?.error || error.message
    }
};
